<template>
<div class="page-container">
  <el-breadcrumb separator="/" class="page-breadcrumb">
    <el-breadcrumb-item>
      APP设置
    </el-breadcrumb-item>
  </el-breadcrumb>
  <el-card shadow="never" class="page-content">
    <div class="page-actions">
    <el-select v-model="appType" placeholder="请选择" clearable>
       <el-option value="Android" label="Android"></el-option>
       <el-option value="iPhone" label="iPhone"></el-option>
    </el-select>
    <el-input placeholder="请输入版本号" v-model="version" clearable>
      <i slot="prefix" class="el-input__icon el-icon-search"></i>
    </el-input>
    <el-button type="primary" @click="handleSearch">搜索</el-button>
    <el-button type="primary" @click="type = 'create',createShow = true">新增</el-button>
    </div>
    <el-table :data="infoList">
      <el-table-column prop="type" label="分类"></el-table-column>
      <el-table-column prop="version" label="版本"></el-table-column>
      <el-table-column label="创建时间">
          <template slot-scope="scope">{{scope.row.createTime | moment}}</template>
      </el-table-column>
      <el-table-column prop="id" v-if="false"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="primary" size="small" circle icon="el-icon-edit" @click="setUpdateInfo(scope.row)"></el-button>
          <el-button type="danger" size="small" circle icon="el-icon-delete" @click="removeInfo(scope.row.id)"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination :size="25" :page="pagination.page" :total="totalCount" @pageChanged="handlePageChanged">
    </pagination>
  </el-card>

  <app-update :showVisible="createShow" :opType="type" @close="closeUpdate"></app-update>
</div>
</template>

<script>
import './store';
import AppUpdate from './components/update';
import Pagination from '../../components/pagination';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'AppSetting',
  components: {
    AppUpdate,
    Pagination
  },
  data(){
    return {
      appType:'',
      version:'',
      type: '',
      createShow: false,
    }
  },
  computed:{
    ...mapState('app', ['totalCount','pagination','infoList']),
  },
  created(){
    this.refreshList();
  },
  methods:{
    ...mapActions('app',['list','remove','buildUpdateInfo']),

    /**更新列表数据*/
    refreshList(data){
      this.list({
        appType: this.appType,
        version: this.version,
        ...data
      })
    },

    /**点击页码触发函数*/
    handlePageChanged(pagination){
      this.refreshList(pagination);
    },

    /**搜索按钮，初始化页码为1*/
    handleSearch(){
      this.refreshList({page:1})
    },

    /**关闭app-update对话框，并刷新数据列表*/
    closeUpdate(){
        this.appType = "";
        this.version = "";
      this.createShow = false;
      this.refreshList();
    },

    /**通过id删除列表数据*/
    removeInfo(id) {
      this.remove({id:id}).then(() => {
          this.$message('删除成功');
          this.refreshList({page:1})
      })
    },

    /**设置更新的信息*/
      setUpdateInfo(info){
        this.buildUpdateInfo({
            id: info.id,
            type: info.type,
            version: info.version,
            contentZh: info.contentZh,
            contentEn: info.contentEn,
            force: info.force,
            url: info.url
        });
        this.type = 'update';
        this.createShow = true;
    }

  }
};
</script>

<style lang="less" scoped>
</style>
